import { staticText } from 'utils/staticText';
import { productRewardBadgeTranslationConfig } from '../../helpers/productRecommendation.i18n';

export const MultiProductBlockTranslations = staticText({
  ...productRewardBadgeTranslationConfig,
  seeAll: {
    _: 'See All',
    zh: '查看所有',
    'zh-hk': '查看所有',
    'zh-tw': '查看所有',
  },
});
